import React, { useState } from 'react';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import CreateNewListModal from '../../lists/CreateNewListModal';
import styles from './styles/styles.module.scss';

const handleListCreated = list => {
  window.location.href = LanguageSupportUtil.wrapUrlSafe(`/explore/list/${list.list_slug}`);
};

export default function CreateListPopupButton() {
  const [showModal, toggleShowModal] = useState(false);
  return (
    <>
      <button className={styles.listPopupBtn} onClick={() => toggleShowModal(true)} title={StringConstantsMixin.strings.SHARE} type="button">
        {StringConstantsMixin.strings.LIST_MODAL.CREATE_A_LIST}
      </button>
      {showModal && <CreateNewListModal handleClose={() => toggleShowModal(false)} handleListCreated={handleListCreated} />}
    </>
  );
}
